import React from 'react';
import styles from './User.module.scss';
import arrow from '../../assets/images/arrow.svg';
import { formatLongStr } from '../../utils/format';

type Props = {
  ont: string;
}

const User: React.FC<Props> = ({ ont }) => (
  <div className={styles.user}>
    <div className={styles.ont}>{formatLongStr(ont, '...', 14, 6)}</div>
    <img className={styles.arrow} src={arrow} alt="arrow" />
  </div>
);

export default User;
